var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 560,
    zoomAndPan: "magnify",
    viewBox: "0 0 420 311.25",
    height: 415,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "07b9a8e2d5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5 1 L 415 1 L 415 310.5 L 5 310.5 Z M 5 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e6e7365bac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 487.703125 217.578125 L 202.449219 467.628906 L -41.191406 189.6875 L 244.066406 -60.363281 Z M 487.703125 217.578125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2039c56c97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 487.703125 217.578125 L 202.449219 467.628906 L -41.191406 189.6875 L 244.066406 -60.363281 Z M 487.703125 217.578125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "06640a67ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.261719 229.511719 C -4.113281 191.183594 5.15625 159.089844 43.066406 133.230469 C 80.980469 107.371094 107.417969 83.140625 122.378906 60.546875 C 137.339844 37.949219 159.8125 20.621094 189.800781 8.554688 C 219.789062 -3.507812 249.660156 -0.980469 279.414062 16.132812 C 309.167969 33.25 338.90625 56.960938 368.636719 87.269531 C 398.363281 117.574219 413.566406 157.453125 414.246094 206.90625 C 414.921875 256.355469 390.96875 287.625 342.386719 300.710938 C 293.804688 313.796875 252.832031 313.628906 219.464844 300.207031 C 186.101562 286.785156 148.570312 281.226562 106.871094 283.539062 C 65.171875 285.847656 34.636719 267.839844 15.261719 229.511719 Z M 15.261719 229.511719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    gradientTransform: "matrix(-273.481727, 239.730835, -225.601462, -257.363127, 471.352534, 204.07307)",
    y1: -0.125159,
    x2: 0,
    gradientUnits: "userSpaceOnUse",
    y2: 1.355267,
    id: "88ab3ea9ce"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.898804%, 8.999634%, 92.199707%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.898804%, 8.999634%, 92.199707%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.898804%, 8.999634%, 92.199707%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.901855%, 9.002686%, 92.150879%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.920166%, 9.024048%, 91.83197%)",
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.935425%, 9.042358%, 91.563416%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.950684%, 9.060669%, 91.293335%)",
    offset: 0.0976563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.967468%, 9.080505%, 91.023254%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.982727%, 9.098816%, 90.753174%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.997986%, 9.117126%, 90.483093%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.013245%, 9.135437%, 90.213013%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.030029%, 9.153748%, 89.942932%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.045288%, 9.172058%, 89.672852%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.060547%, 9.190369%, 89.402771%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.075806%, 9.208679%, 89.13269%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.09259%, 9.228516%, 88.86261%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.107849%, 9.246826%, 88.592529%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.123108%, 9.265137%, 88.322449%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.138367%, 9.283447%, 88.052368%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.155151%, 9.301758%, 87.782288%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.17041%, 9.320068%, 87.512207%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.185669%, 9.338379%, 87.242126%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.200928%, 9.356689%, 86.972046%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.217712%, 9.376526%, 86.701965%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.232971%, 9.394836%, 86.431885%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.24823%, 9.413147%, 86.161804%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.263489%, 9.431458%, 85.891724%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.280273%, 9.449768%, 85.621643%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.295532%, 9.468079%, 85.351562%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.310791%, 9.486389%, 85.081482%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.32605%, 9.5047%, 84.811401%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.341309%, 9.524536%, 84.541321%)",
    offset: 0.195313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.356567%, 9.542847%, 84.27124%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.373352%, 9.561157%, 84.00116%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.388611%, 9.579468%, 83.731079%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.40387%, 9.597778%, 83.460999%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.419128%, 9.616089%, 83.190918%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.435913%, 9.634399%, 82.920837%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.451172%, 9.65271%, 82.650757%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.466431%, 9.672546%, 82.380676%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.481689%, 9.690857%, 82.110596%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.498474%, 9.709167%, 81.840515%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.513733%, 9.727478%, 81.570435%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.528992%, 9.745789%, 81.300354%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.54425%, 9.764099%, 81.030273%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.561035%, 9.78241%, 80.760193%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.576294%, 9.80072%, 80.490112%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.591553%, 9.820557%, 80.220032%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.606812%, 9.838867%, 79.949951%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.623596%, 9.857178%, 79.679871%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.638855%, 9.875488%, 79.40979%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.654114%, 9.893799%, 79.139709%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.669373%, 9.912109%, 78.869629%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.686157%, 9.93042%, 78.599548%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.701416%, 9.94873%, 78.329468%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.716675%, 9.968567%, 78.059387%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.731934%, 9.986877%, 77.789307%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.748718%, 10.005188%, 77.519226%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.763977%, 10.023499%, 77.249146%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.779236%, 10.041809%, 76.979065%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.794495%, 10.06012%, 76.708984%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.809753%, 10.07843%, 76.438904%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.825012%, 10.096741%, 76.168823%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.841797%, 10.116577%, 75.898743%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.857056%, 10.134888%, 75.628662%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.872314%, 10.153198%, 75.358582%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.887573%, 10.171509%, 75.088501%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.904358%, 10.189819%, 74.81842%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.919617%, 10.20813%, 74.54834%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.934875%, 10.22644%, 74.278259%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.950134%, 10.244751%, 74.008179%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.966919%, 10.264587%, 73.738098%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.982178%, 10.282898%, 73.468018%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.997437%, 10.301208%, 73.197937%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.012695%, 10.319519%, 72.927856%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.02948%, 10.33783%, 72.657776%)",
    offset: 0.367187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.044739%, 10.35614%, 72.387695%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.059998%, 10.375977%, 72.117615%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.075256%, 10.394287%, 71.847534%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.092041%, 10.412598%, 71.577454%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.1073%, 10.430908%, 71.307373%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.122559%, 10.449219%, 71.037292%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.137817%, 10.467529%, 70.767212%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.154602%, 10.48584%, 70.497131%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.169861%, 10.50415%, 70.227051%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.18512%, 10.523987%, 69.95697%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.200378%, 10.542297%, 69.68689%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.215637%, 10.560608%, 69.418335%)",
    offset: 0.414063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.230896%, 10.578918%, 69.148254%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.247681%, 10.597229%, 68.878174%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.262939%, 10.61554%, 68.608093%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.278198%, 10.63385%, 68.338013%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.293457%, 10.652161%, 68.067932%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.310242%, 10.671997%, 67.797852%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.3255%, 10.690308%, 67.527771%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.340759%, 10.708618%, 67.25769%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.356018%, 10.726929%, 66.98761%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.372803%, 10.745239%, 66.717529%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.388062%, 10.76355%, 66.447449%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.40332%, 10.78186%, 66.177368%)",
    offset: 0.460937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.418579%, 10.800171%, 65.907288%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.435364%, 10.820007%, 65.637207%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.450623%, 10.838318%, 65.367126%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.465881%, 10.856628%, 65.097046%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.48114%, 10.874939%, 64.826965%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.497925%, 10.89325%, 64.556885%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.513184%, 10.91156%, 64.286804%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.528442%, 10.929871%, 64.016724%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.543701%, 10.948181%, 63.746643%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.560486%, 10.968018%, 63.476562%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.575745%, 10.986328%, 63.206482%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.591003%, 11.004639%, 62.936401%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.606262%, 11.022949%, 62.666321%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.623047%, 11.04126%, 62.39624%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.638306%, 11.05957%, 62.12616%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.653564%, 11.077881%, 61.856079%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.668823%, 11.096191%, 61.585999%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.684082%, 11.116028%, 61.315918%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.699341%, 11.134338%, 61.045837%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.716125%, 11.152649%, 60.775757%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.731384%, 11.170959%, 60.505676%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.746643%, 11.18927%, 60.235596%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.761902%, 11.207581%, 59.965515%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.778687%, 11.225891%, 59.695435%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.793945%, 11.244202%, 59.425354%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.809204%, 11.264038%, 59.155273%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.824463%, 11.282349%, 58.885193%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.841248%, 11.300659%, 58.615112%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.856506%, 11.31897%, 58.345032%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.871765%, 11.33728%, 58.074951%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.887024%, 11.355591%, 57.804871%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.903809%, 11.373901%, 57.53479%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.919067%, 11.392212%, 57.264709%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.934326%, 11.412048%, 56.994629%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.949585%, 11.430359%, 56.724548%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.96637%, 11.448669%, 56.454468%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.981628%, 11.46698%, 56.184387%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.996887%, 11.485291%, 55.914307%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.012146%, 11.503601%, 55.644226%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.028931%, 11.521912%, 55.374146%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.044189%, 11.540222%, 55.104065%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.059448%, 11.560059%, 54.833984%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.074707%, 11.578369%, 54.563904%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.091492%, 11.59668%, 54.293823%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.10675%, 11.61499%, 54.023743%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.122009%, 11.633301%, 53.753662%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.137268%, 11.651611%, 53.483582%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.152527%, 11.669922%, 53.213501%)",
    offset: 0.648437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.167786%, 11.688232%, 52.94342%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.18457%, 11.708069%, 52.67334%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.199829%, 11.726379%, 52.403259%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.215088%, 11.74469%, 52.133179%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.230347%, 11.763%, 51.863098%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.247131%, 11.781311%, 51.593018%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.26239%, 11.799622%, 51.322937%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.277649%, 11.817932%, 51.052856%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.292908%, 11.836243%, 50.782776%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.309692%, 11.856079%, 50.512695%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.324951%, 11.87439%, 50.242615%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.34021%, 11.8927%, 49.972534%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.355469%, 11.911011%, 49.702454%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.372253%, 11.929321%, 49.432373%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.387512%, 11.947632%, 49.162292%)",
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.402771%, 11.965942%, 48.892212%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.41803%, 11.984253%, 48.622131%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.434814%, 12.004089%, 48.352051%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.450073%, 12.0224%, 48.08197%)",
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.465332%, 12.04071%, 47.81189%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.480591%, 12.059021%, 47.541809%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.497375%, 12.077332%, 47.273254%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.512634%, 12.095642%, 47.003174%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.527893%, 12.115479%, 46.733093%)",
    offset: 0.742187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.543152%, 12.133789%, 46.463013%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.558411%, 12.1521%, 46.192932%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.573669%, 12.17041%, 45.922852%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.590454%, 12.188721%, 45.652771%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.595032%, 12.193298%, 45.574951%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.599609%, 12.199402%, 45.498657%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.599609%, 12.199402%, 45.498657%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.599609%, 12.199402%, 45.498657%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.599609%, 12.199402%, 45.498657%)",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#07b9a8e2d5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e6e7365bac)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2039c56c97)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#06640a67ac)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#88ab3ea9ce)",
    d: "M 568.835938 175.582031 L 234.851562 -205.425781 L -153.410156 134.917969 L 180.578125 515.925781 Z M 568.835938 175.582031 ",
    fillRule: "nonzero"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.218797, 163.62314)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.75 -0.875 L 10.390625 -0.15625 L 11.265625 0.359375 L 12.78125 0.3125 L 13.65625 0 L 14.296875 -0.84375 L 14.65625 -1.515625 L 14.890625 -2.390625 L 15.28125 -3.109375 L 15.484375 -3.78125 L 15.84375 -4.625 L 16.046875 -5.25 L 17.28125 -8.203125 L 17.515625 -9.03125 L 18.234375 -10.546875 L 18.75 -12.109375 L 19.15625 -11.984375 L 19.546875 -11.3125 L 19.78125 -10.46875 L 20.46875 -9.109375 L 22.734375 -2.984375 L 23.328125 -1.671875 L 23.5625 -0.921875 L 24.328125 -0.078125 L 25.234375 0.390625 L 26 0.359375 L 26.671875 0.234375 L 27.625 -0.078125 L 28.234375 -0.796875 L 28.46875 -1.546875 L 28.828125 -2.265625 L 31.21875 -9.203125 L 31.578125 -9.875 L 32.890625 -13.25 L 33.203125 -14.375 L 33.5625 -15.09375 L 33.71875 -15.765625 L 36.265625 -22.53125 L 36.46875 -23.40625 L 36.859375 -24.125 L 37.625 -26.5625 L 37.390625 -27.515625 L 36.59375 -27.703125 L 35.796875 -27.828125 L 34.390625 -27.75 L 32.8125 -27.828125 L 31.96875 -27.75 L 31.21875 -27.875 L 30.375 -27.46875 L 29.703125 -26.640625 L 29.5 -25.875 L 29.140625 -25.203125 L 26.953125 -18.1875 L 26.796875 -17.390625 L 26.28125 -15.71875 L 26 -14.046875 L 25.765625 -13.296875 L 25.359375 -13.34375 L 24.5625 -15.609375 L 24.359375 -16.40625 L 22.65625 -20.90625 L 22.25 -22.421875 L 21.9375 -23.171875 L 21.453125 -24.765625 L 21.140625 -25.4375 L 20.828125 -26.15625 L 20.265625 -26.953125 L 19.421875 -27.4375 L 18.546875 -27.4375 L 17.75 -27.03125 L 17.078125 -26.234375 L 15.765625 -22.296875 L 15.171875 -20.859375 L 13.734375 -16.25 L 13.34375 -15.640625 L 13.171875 -14.8125 L 12.578125 -13.296875 L 12.265625 -13.25 L 12.109375 -14.21875 L 9.5625 -22.890625 L 9.234375 -23.5625 L 8.765625 -25.125 L 8.59375 -25.921875 L 8.28125 -26.71875 L 7.5625 -27.34375 L 6.8125 -27.703125 L 3.625 -27.75 L 2.90625 -27.90625 L 2.1875 -27.796875 L 1.359375 -27.75 L 0.515625 -27.515625 L 0.359375 -26.59375 L 0.5625 -25.515625 L 2.234375 -20.984375 L 2.59375 -20.296875 L 4.21875 -15.84375 L 4.453125 -14.96875 L 5.578125 -11.984375 L 5.9375 -11.34375 L 9.15625 -2.3125 L 9.515625 -1.546875 Z M 9.75 -0.875 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(96.196095, 163.62314)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.03125 -1.109375 L 3.34375 -0.28125 L 4.265625 0.078125 L 5.015625 0.078125 L 6.25 -0.046875 L 7.40625 0 L 8.234375 0.125 L 9.078125 0.046875 L 9.953125 -0.3125 L 10.265625 -1.109375 L 10.3125 -1.90625 L 10.1875 -2.78125 L 10.265625 -3.5 L 10.1875 -4.296875 L 10.265625 -5.0625 L 10.234375 -5.9375 L 10.3125 -6.765625 L 10.1875 -9.90625 L 10.59375 -10.75 L 11.390625 -11.234375 L 12.21875 -11.234375 L 12.9375 -11.140625 L 15.28125 -11.140625 L 16.078125 -11.234375 L 16.875 -11.140625 L 17.640625 -11.140625 L 18.359375 -10.75 L 18.75 -9.953125 L 18.875 -7.53125 L 18.75 -6.765625 L 18.90625 -3.9375 L 18.75 -2.75 L 18.875 -1.1875 L 19.265625 -0.359375 L 20.0625 0.046875 L 20.859375 -0.046875 L 22.0625 0.078125 L 24.796875 0.078125 L 25.59375 -0.359375 L 26.03125 -1.109375 L 26.203125 -2.75 L 26.203125 -9.15625 L 26.03125 -10.671875 L 26.078125 -11.46875 L 26 -12.296875 L 26 -13.09375 L 26.109375 -13.9375 L 26.078125 -15.453125 L 26.15625 -16.328125 L 26.03125 -20.21875 L 26.234375 -23.53125 L 26.078125 -24.28125 L 26 -25.046875 L 26.15625 -25.84375 L 26.078125 -26.640625 L 25.671875 -27.4375 L 24.4375 -27.828125 L 22.421875 -27.875 L 21.140625 -27.75 L 20.34375 -27.75 L 19.15625 -27.390625 L 18.828125 -26.234375 L 18.90625 -21.890625 L 18.75 -21.21875 L 18.75 -18.90625 L 18.3125 -18.109375 L 17.640625 -17.71875 L 16.046875 -17.71875 L 15.328125 -17.796875 L 11.46875 -17.75 L 10.625 -18.109375 L 10.3125 -18.875 L 10.3125 -21.265625 L 10.390625 -21.96875 L 10.265625 -25.921875 L 10.3125 -26.59375 L 9.828125 -27.4375 L 8.59375 -27.828125 L 6.25 -27.75 L 5.453125 -27.828125 L 4.703125 -27.75 L 3.46875 -27.390625 L 3.03125 -26.71875 L 2.90625 -25.84375 L 2.90625 -25.078125 L 2.984375 -24.203125 L 2.859375 -23.453125 L 3.0625 -21.0625 L 2.953125 -20.1875 L 3.03125 -19.515625 L 2.859375 -18.71875 L 3.03125 -16.28125 L 2.953125 -15.453125 L 2.953125 -13.140625 L 3.0625 -12.375 L 2.984375 -11.140625 L 3.0625 -10.234375 L 2.953125 -8.359375 L 3.03125 -7.484375 L 2.90625 -6.6875 L 3.03125 -5.96875 L 2.953125 -5.171875 Z M 3.03125 -1.109375 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(125.335907, 163.62314)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.859375 -1.15625 L 3.390625 -0.390625 L 4.140625 0.046875 L 13.140625 -0.046875 L 13.859375 0.078125 L 16.28125 -0.046875 L 18.71875 0.125 L 19.46875 0.046875 L 20.296875 -0.359375 L 20.65625 -1.109375 L 20.75 -1.875 L 20.703125 -4.34375 L 20.78125 -5.09375 L 20.265625 -5.890625 L 19.0625 -6.296875 L 13.8125 -6.375 L 13.0625 -6.25 L 12.1875 -6.328125 L 11.3125 -6.25 L 10.46875 -6.734375 L 10.109375 -7.96875 L 10.15625 -9.90625 L 10.515625 -10.75 L 11.234375 -11.1875 L 12.78125 -11.1875 L 13.578125 -11.265625 L 15.6875 -11.140625 L 16.765625 -11.234375 L 17.59375 -11.140625 L 18.3125 -11.1875 L 19.109375 -11.625 L 19.515625 -12.375 L 19.59375 -15.53125 L 19.515625 -16.328125 L 19.15625 -17.078125 L 18.46875 -17.515625 L 16.875 -17.5625 L 16.078125 -17.484375 L 15.25 -17.484375 L 14.328125 -17.5625 L 11.1875 -17.515625 L 10.515625 -17.953125 L 10.03125 -18.671875 L 9.953125 -19.90625 L 10.34375 -21.0625 L 11.578125 -21.421875 L 19.234375 -21.453125 L 20.0625 -21.890625 L 20.5 -22.609375 L 20.421875 -24.25 L 20.296875 -25 L 20.34375 -25.875 L 20.46875 -26.640625 L 20.0625 -27.4375 L 19.234375 -27.796875 L 16.046875 -27.828125 L 15.328125 -27.75 L 14.53125 -27.875 L 12.78125 -27.796875 L 11.984375 -27.875 L 10.4375 -27.828125 L 9.71875 -27.90625 L 4.5 -27.796875 L 3.34375 -27.515625 L 2.953125 -26.640625 L 3.03125 -25.046875 L 2.859375 -23.890625 L 3.03125 -21.859375 L 2.953125 -21.015625 L 3.03125 -20.296875 L 3.03125 -13.171875 L 2.90625 -12.34375 L 3.03125 -10.796875 L 2.953125 -9.203125 L 3.0625 -8.359375 L 2.984375 -7.484375 L 3.03125 -6.734375 L 2.90625 -6.015625 L 2.984375 -5.09375 L 2.984375 -4.296875 L 3.0625 -2.75 L 3.03125 -1.953125 Z M 2.859375 -1.15625 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.146177, 163.62314)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.0625 -1.28125 L 3.34375 -0.390625 L 4.140625 0 L 4.890625 0.046875 L 6.53125 -0.078125 L 7.359375 0 L 8.5625 0 L 9.796875 -0.390625 L 10.078125 -1.15625 L 10.15625 -1.984375 L 10 -2.828125 L 10.109375 -4.53125 L 10.03125 -7 L 10.390625 -7.796875 L 11.1875 -8.203125 L 11.90625 -8.203125 L 12.625 -8.234375 L 13.609375 -7.921875 L 14.25 -7.25 L 15.28125 -5.859375 L 15.5625 -5.09375 L 16.6875 -3.109375 L 17.203125 -2.34375 L 17.5625 -1.671875 L 18.03125 -1.03125 L 18.828125 -0.3125 L 19.828125 -0.078125 L 21.265625 0 L 22.140625 -0.078125 L 22.9375 0 L 24.53125 0 L 25.40625 -0.078125 L 26.234375 -0.28125 L 26.390625 -1.109375 L 25.875 -2.109375 L 24.609375 -4.0625 L 24.25 -4.734375 L 23.765625 -5.453125 L 23.375 -6.171875 L 22.859375 -6.8125 L 21.65625 -8.875 L 21.53125 -9.828125 L 21.96875 -10.671875 L 23.09375 -11.75 L 23.5625 -12.421875 L 23.84375 -13.171875 L 24.28125 -13.890625 L 24.5625 -14.578125 L 25 -16.078125 L 25.046875 -19.234375 L 24.84375 -19.984375 L 24.71875 -20.75 L 24.53125 -21.53125 L 23.453125 -23.734375 L 22.890625 -24.328125 L 22.53125 -24.921875 L 20.546875 -26.4375 L 19.15625 -27.15625 L 15.84375 -27.828125 L 14.84375 -27.90625 L 13.703125 -27.875 L 12.8125 -27.90625 L 12.015625 -27.828125 L 11.140625 -27.90625 L 10.46875 -27.828125 L 8.078125 -27.90625 L 7.328125 -27.796875 L 5.6875 -27.953125 L 4.9375 -27.828125 L 4.0625 -27.875 L 3.296875 -27.515625 L 2.984375 -26.671875 L 2.859375 -15.53125 L 2.984375 -14.375 L 2.984375 -12.375 L 2.90625 -11.546875 L 2.859375 -10.03125 L 2.984375 -9.15625 L 2.859375 -7.53125 L 3.03125 -5.21875 L 2.953125 -4.375 Z M 11.1875 -14.65625 L 10.515625 -15.015625 L 10.109375 -15.84375 L 10 -20.296875 L 10.46875 -21.09375 L 11.265625 -21.5 L 11.90625 -21.53125 L 14.09375 -21.5 L 15.921875 -21.265625 L 17.15625 -20.5 L 17.5625 -19.90625 L 17.84375 -19.265625 L 17.921875 -18.109375 L 17.796875 -17.046875 L 17.484375 -16.25 L 17.046875 -15.5625 L 16.5625 -15.09375 L 15.96875 -14.8125 L 12.859375 -14.53125 L 12.0625 -14.65625 Z M 11.1875 -14.65625 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(175.733461, 163.62314)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.859375 -1.15625 L 3.390625 -0.390625 L 4.140625 0.046875 L 13.140625 -0.046875 L 13.859375 0.078125 L 16.28125 -0.046875 L 18.71875 0.125 L 19.46875 0.046875 L 20.296875 -0.359375 L 20.65625 -1.109375 L 20.75 -1.875 L 20.703125 -4.34375 L 20.78125 -5.09375 L 20.265625 -5.890625 L 19.0625 -6.296875 L 13.8125 -6.375 L 13.0625 -6.25 L 12.1875 -6.328125 L 11.3125 -6.25 L 10.46875 -6.734375 L 10.109375 -7.96875 L 10.15625 -9.90625 L 10.515625 -10.75 L 11.234375 -11.1875 L 12.78125 -11.1875 L 13.578125 -11.265625 L 15.6875 -11.140625 L 16.765625 -11.234375 L 17.59375 -11.140625 L 18.3125 -11.1875 L 19.109375 -11.625 L 19.515625 -12.375 L 19.59375 -15.53125 L 19.515625 -16.328125 L 19.15625 -17.078125 L 18.46875 -17.515625 L 16.875 -17.5625 L 16.078125 -17.484375 L 15.25 -17.484375 L 14.328125 -17.5625 L 11.1875 -17.515625 L 10.515625 -17.953125 L 10.03125 -18.671875 L 9.953125 -19.90625 L 10.34375 -21.0625 L 11.578125 -21.421875 L 19.234375 -21.453125 L 20.0625 -21.890625 L 20.5 -22.609375 L 20.421875 -24.25 L 20.296875 -25 L 20.34375 -25.875 L 20.46875 -26.640625 L 20.0625 -27.4375 L 19.234375 -27.796875 L 16.046875 -27.828125 L 15.328125 -27.75 L 14.53125 -27.875 L 12.78125 -27.796875 L 11.984375 -27.875 L 10.4375 -27.828125 L 9.71875 -27.90625 L 4.5 -27.796875 L 3.34375 -27.515625 L 2.953125 -26.640625 L 3.03125 -25.046875 L 2.859375 -23.890625 L 3.03125 -21.859375 L 2.953125 -21.015625 L 3.03125 -20.296875 L 3.03125 -13.171875 L 2.90625 -12.34375 L 3.03125 -10.796875 L 2.953125 -9.203125 L 3.0625 -8.359375 L 2.984375 -7.484375 L 3.03125 -6.734375 L 2.90625 -6.015625 L 2.984375 -5.09375 L 2.984375 -4.296875 L 3.0625 -2.75 L 3.03125 -1.953125 Z M 2.859375 -1.15625 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(198.543731, 163.62314)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(209.331827, 163.62314)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0.515625 -1.078125 L 0.71875 -0.234375 L 1.515625 -0.046875 L 5.015625 -0.046875 L 6.046875 0.078125 L 6.96875 -0.3125 L 7.6875 -1.03125 L 8.359375 -2.390625 L 9.03125 -3.140625 L 10 -3.546875 L 10.796875 -3.46875 L 13.015625 -3.5 L 13.859375 -3.390625 L 14.765625 -3.5 L 15.484375 -3.5 L 16.328125 -3.421875 L 18.1875 -3.5 L 19.515625 -3.0625 L 20.34375 -2.421875 L 20.546875 -1.71875 L 20.984375 -1 L 21.65625 -0.359375 L 22.6875 0.046875 L 23.40625 -0.046875 L 24.796875 0.078125 L 27.265625 0 L 27.984375 -0.234375 L 28.140625 -1.078125 L 27.90625 -2.0625 L 27.625 -2.78125 L 27.109375 -3.46875 L 26.875 -4.265625 L 26.46875 -4.859375 L 26.234375 -5.609375 L 25.5625 -7.046875 L 25.28125 -7.796875 L 24.890625 -8.484375 L 24.328125 -9.953125 L 23.890625 -10.59375 L 23.5625 -11.390625 L 23.203125 -12.0625 L 22.9375 -12.859375 L 22.578125 -13.453125 L 22.328125 -14.25 L 21.890625 -14.96875 L 21.578125 -15.640625 L 21.1875 -16.328125 L 20.984375 -17.078125 L 20.1875 -18.46875 L 19.953125 -19.234375 L 19.234375 -20.75 L 19.03125 -21.375 L 18.4375 -22.765625 L 17.640625 -24.25 L 17 -25.765625 L 16.640625 -26.359375 L 16.40625 -27.109375 L 15.6875 -27.875 L 14.328125 -28.234375 L 13.0625 -27.828125 L 12.296875 -27.109375 L 12.0625 -26.390625 L 10.34375 -22.8125 L 9.90625 -22.09375 L 7.6875 -17.078125 L 7.484375 -16.40625 L 7.046875 -15.6875 L 6.40625 -14.25 L 5.8125 -13.21875 L 5.53125 -12.46875 L 4.984375 -11.421875 L 4.734375 -10.59375 L 4.375 -9.953125 L 4.09375 -9.15625 L 2.984375 -7.09375 L 1.828125 -4.1875 L 1.359375 -3.546875 L 1 -2.75 Z M 12.8125 -9.828125 L 12.0625 -10.15625 L 11.9375 -10.953125 L 13.53125 -14.578125 L 13.890625 -15.203125 L 14.40625 -15.609375 L 14.890625 -15.28125 L 15.40625 -13.734375 L 15.84375 -13.0625 L 16 -12.421875 L 16.40625 -11.625 L 16.6875 -10.90625 L 16.609375 -10.1875 L 15.921875 -9.875 Z M 12.8125 -9.828125 "
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(238.232788, 163.62314)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.0625 -1.28125 L 3.34375 -0.390625 L 4.140625 0 L 4.890625 0.046875 L 6.53125 -0.078125 L 7.359375 0 L 8.5625 0 L 9.796875 -0.390625 L 10.078125 -1.15625 L 10.15625 -1.984375 L 10 -2.828125 L 10.109375 -4.53125 L 10.03125 -7 L 10.390625 -7.796875 L 11.1875 -8.203125 L 11.90625 -8.203125 L 12.625 -8.234375 L 13.609375 -7.921875 L 14.25 -7.25 L 15.28125 -5.859375 L 15.5625 -5.09375 L 16.6875 -3.109375 L 17.203125 -2.34375 L 17.5625 -1.671875 L 18.03125 -1.03125 L 18.828125 -0.3125 L 19.828125 -0.078125 L 21.265625 0 L 22.140625 -0.078125 L 22.9375 0 L 24.53125 0 L 25.40625 -0.078125 L 26.234375 -0.28125 L 26.390625 -1.109375 L 25.875 -2.109375 L 24.609375 -4.0625 L 24.25 -4.734375 L 23.765625 -5.453125 L 23.375 -6.171875 L 22.859375 -6.8125 L 21.65625 -8.875 L 21.53125 -9.828125 L 21.96875 -10.671875 L 23.09375 -11.75 L 23.5625 -12.421875 L 23.84375 -13.171875 L 24.28125 -13.890625 L 24.5625 -14.578125 L 25 -16.078125 L 25.046875 -19.234375 L 24.84375 -19.984375 L 24.71875 -20.75 L 24.53125 -21.53125 L 23.453125 -23.734375 L 22.890625 -24.328125 L 22.53125 -24.921875 L 20.546875 -26.4375 L 19.15625 -27.15625 L 15.84375 -27.828125 L 14.84375 -27.90625 L 13.703125 -27.875 L 12.8125 -27.90625 L 12.015625 -27.828125 L 11.140625 -27.90625 L 10.46875 -27.828125 L 8.078125 -27.90625 L 7.328125 -27.796875 L 5.6875 -27.953125 L 4.9375 -27.828125 L 4.0625 -27.875 L 3.296875 -27.515625 L 2.984375 -26.671875 L 2.859375 -15.53125 L 2.984375 -14.375 L 2.984375 -12.375 L 2.90625 -11.546875 L 2.859375 -10.03125 L 2.984375 -9.15625 L 2.859375 -7.53125 L 3.03125 -5.21875 L 2.953125 -4.375 Z M 11.1875 -14.65625 L 10.515625 -15.015625 L 10.109375 -15.84375 L 10 -20.296875 L 10.46875 -21.09375 L 11.265625 -21.5 L 11.90625 -21.53125 L 14.09375 -21.5 L 15.921875 -21.265625 L 17.15625 -20.5 L 17.5625 -19.90625 L 17.84375 -19.265625 L 17.921875 -18.109375 L 17.796875 -17.046875 L 17.484375 -16.25 L 17.046875 -15.5625 L 16.5625 -15.09375 L 15.96875 -14.8125 L 12.859375 -14.53125 L 12.0625 -14.65625 Z M 11.1875 -14.65625 "
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(265.820072, 163.62314)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.859375 -1.15625 L 3.390625 -0.390625 L 4.140625 0.046875 L 13.140625 -0.046875 L 13.859375 0.078125 L 16.28125 -0.046875 L 18.71875 0.125 L 19.46875 0.046875 L 20.296875 -0.359375 L 20.65625 -1.109375 L 20.75 -1.875 L 20.703125 -4.34375 L 20.78125 -5.09375 L 20.265625 -5.890625 L 19.0625 -6.296875 L 13.8125 -6.375 L 13.0625 -6.25 L 12.1875 -6.328125 L 11.3125 -6.25 L 10.46875 -6.734375 L 10.109375 -7.96875 L 10.15625 -9.90625 L 10.515625 -10.75 L 11.234375 -11.1875 L 12.78125 -11.1875 L 13.578125 -11.265625 L 15.6875 -11.140625 L 16.765625 -11.234375 L 17.59375 -11.140625 L 18.3125 -11.1875 L 19.109375 -11.625 L 19.515625 -12.375 L 19.59375 -15.53125 L 19.515625 -16.328125 L 19.15625 -17.078125 L 18.46875 -17.515625 L 16.875 -17.5625 L 16.078125 -17.484375 L 15.25 -17.484375 L 14.328125 -17.5625 L 11.1875 -17.515625 L 10.515625 -17.953125 L 10.03125 -18.671875 L 9.953125 -19.90625 L 10.34375 -21.0625 L 11.578125 -21.421875 L 19.234375 -21.453125 L 20.0625 -21.890625 L 20.5 -22.609375 L 20.421875 -24.25 L 20.296875 -25 L 20.34375 -25.875 L 20.46875 -26.640625 L 20.0625 -27.4375 L 19.234375 -27.796875 L 16.046875 -27.828125 L 15.328125 -27.75 L 14.53125 -27.875 L 12.78125 -27.796875 L 11.984375 -27.875 L 10.4375 -27.828125 L 9.71875 -27.90625 L 4.5 -27.796875 L 3.34375 -27.515625 L 2.953125 -26.640625 L 3.03125 -25.046875 L 2.859375 -23.890625 L 3.03125 -21.859375 L 2.953125 -21.015625 L 3.03125 -20.296875 L 3.03125 -13.171875 L 2.90625 -12.34375 L 3.03125 -10.796875 L 2.953125 -9.203125 L 3.0625 -8.359375 L 2.984375 -7.484375 L 3.03125 -6.734375 L 2.90625 -6.015625 L 2.984375 -5.09375 L 2.984375 -4.296875 L 3.0625 -2.75 L 3.03125 -1.953125 Z M 2.859375 -1.15625 "
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.630342, 163.62314)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(299.418426, 163.62314)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 9.15625 -1.109375 L 9.59375 -0.4375 L 10.34375 -0.046875 L 11.78125 0.046875 L 12.578125 -0.046875 L 13.421875 0 L 14.53125 -0.046875 L 15.71875 -0.4375 L 16.125 -1.234375 L 16.125 -1.90625 L 16.046875 -2.75 L 16.078125 -3.5 L 16.046875 -4.21875 L 16.25 -6.65625 L 16.125 -7.484375 L 16.25 -9.796875 L 16.078125 -10.515625 L 16.28125 -11.671875 L 17.671875 -14.09375 L 18 -14.84375 L 18.4375 -15.53125 L 19.421875 -16.84375 L 24 -24.40625 L 24.484375 -25 L 24.765625 -25.71875 L 25.328125 -26.671875 L 25.203125 -27.625 L 24.4375 -27.953125 L 23.65625 -27.828125 L 22.09375 -27.953125 L 21.265625 -27.828125 L 19.75 -27.828125 L 18.984375 -27.90625 L 18 -27.515625 L 17.15625 -26.75 L 16.484375 -25.40625 L 15.96875 -24.640625 L 15.71875 -23.890625 L 14.8125 -22.578125 L 14.21875 -21.140625 L 12.90625 -18.984375 L 12.34375 -18.90625 L 11.421875 -20.34375 L 11.0625 -21.0625 L 10.828125 -21.859375 L 8.84375 -25.359375 L 8.40625 -26.03125 L 8.078125 -26.828125 L 7.203125 -27.46875 L 6.203125 -27.90625 L 0.953125 -27.828125 L 0.078125 -27.59375 L 0 -26.71875 L 0.390625 -25.765625 L 4.703125 -18.953125 L 5.015625 -18.28125 L 8.5625 -12.703125 L 8.875 -11.671875 L 9.078125 -10.515625 L 9.03125 -7.359375 L 9.109375 -6.5625 L 9.15625 -5.8125 L 9.078125 -5.09375 L 9.03125 -3.578125 L 9.234375 -1.953125 Z M 9.15625 -1.109375 "
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(324.736641, 163.62314)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 14.890625 0.484375 L 17.125 0.4375 L 19.515625 0.125 L 22.5 -0.875 L 23.8125 -1.59375 L 24.40625 -2.0625 L 25.15625 -2.421875 L 26.28125 -3.390625 L 26.796875 -4.09375 L 27.34375 -4.65625 L 29.109375 -7.328125 L 29.703125 -8.84375 L 30.015625 -10.34375 L 30.0625 -11.0625 L 30.25 -11.859375 L 30.296875 -12.703125 L 30.453125 -13.859375 L 30.34375 -15.84375 L 30.0625 -17.484375 L 29.0625 -20.46875 L 28.3125 -21.9375 L 27.4375 -23.125 L 26.3125 -24.359375 L 25.15625 -25.359375 L 24.25 -26 L 23.046875 -26.515625 L 22.453125 -26.953125 L 19.390625 -27.90625 L 17.078125 -28.3125 L 16 -28.34375 L 11.78125 -27.75 L 8.796875 -26.640625 L 8.203125 -26.203125 L 7.484375 -25.84375 L 6.125 -24.84375 L 4.1875 -22.578125 L 2.953125 -20.46875 L 2.34375 -18.953125 L 1.671875 -15.890625 L 1.546875 -12.65625 L 1.671875 -11.828125 L 1.875 -11.109375 L 1.953125 -10.34375 L 2.3125 -8.84375 L 4.140625 -5.21875 L 4.625 -4.734375 L 5.140625 -4.09375 L 5.734375 -3.546875 L 6.171875 -3.03125 L 7.484375 -1.984375 L 10.59375 -0.390625 L 11.75 0 L 12.625 0.078125 L 14.046875 0.390625 Z M 17.125 -6.5625 L 14.9375 -6.5625 L 14.046875 -6.6875 L 12.625 -7.28125 L 11.984375 -7.640625 L 10.90625 -8.515625 L 10.390625 -9.078125 L 9.828125 -9.828125 L 9.640625 -10.46875 L 9.28125 -11.1875 L 8.953125 -12.65625 L 8.953125 -15.09375 L 9.15625 -15.8125 L 9.28125 -16.5625 L 9.59375 -17.28125 L 9.828125 -18 L 10.796875 -19.265625 L 12.78125 -20.625 L 13.296875 -20.828125 L 14.84375 -21.21875 L 15.96875 -21.296875 L 17.875 -21.0625 L 18.59375 -20.90625 L 19.3125 -20.578125 L 20.546875 -19.703125 L 22.09375 -18.078125 L 22.578125 -16.5625 L 22.9375 -15.8125 L 23.046875 -15.09375 L 22.96875 -12.65625 L 22.65625 -11.1875 L 22.375 -10.46875 L 21.9375 -9.75 L 21.703125 -9.15625 L 21.140625 -8.515625 L 19.234375 -7.203125 L 18.515625 -7 L 17.921875 -6.734375 Z M 17.125 -6.5625 "
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(356.663048, 163.62314)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 11.75 0.3125 L 13.65625 0.484375 L 15.640625 0.390625 L 17.234375 0.046875 L 18.078125 -0.28125 L 18.875 -0.484375 L 19.515625 -0.875 L 20.21875 -1.1875 L 20.859375 -1.625 L 22.65625 -3.21875 L 23.09375 -3.9375 L 23.609375 -4.53125 L 23.84375 -5.328125 L 24.25 -6.015625 L 24.53125 -6.765625 L 24.796875 -10.796875 L 24.6875 -14.015625 L 24.84375 -14.84375 L 24.84375 -15.5625 L 24.6875 -16.359375 L 24.640625 -17.125 L 24.71875 -17.953125 L 24.6875 -19.0625 L 24.765625 -20.296875 L 24.71875 -21.1875 L 24.84375 -21.9375 L 24.71875 -22.734375 L 24.765625 -25.953125 L 24.640625 -26.640625 L 24.328125 -27.515625 L 23.046875 -27.875 L 19.3125 -27.90625 L 18.4375 -27.546875 L 18.03125 -26.671875 L 18.078125 -22.765625 L 18 -21.96875 L 18.03125 -20.421875 L 17.953125 -19.59375 L 18.078125 -18.75 L 17.953125 -15.609375 L 18.109375 -14.890625 L 18.03125 -14.015625 L 18.078125 -12.578125 L 18 -11.78125 L 18.03125 -9.75 L 17.875 -8.484375 L 17.515625 -7.71875 L 17.15625 -7.171875 L 16.515625 -6.5625 L 14.9375 -6.046875 L 13.859375 -5.96875 L 12.546875 -6.046875 L 11.828125 -6.25 L 10.953125 -6.6875 L 10.34375 -7.203125 L 9.875 -7.765625 L 9.640625 -8.59375 L 9.5625 -15.609375 L 9.4375 -16.40625 L 9.390625 -18.875 L 9.46875 -19.59375 L 9.46875 -22.765625 L 9.359375 -23.921875 L 9.359375 -24.6875 L 9.5625 -25.875 L 9.5625 -26.71875 L 9.109375 -27.46875 L 8.15625 -27.828125 L 3.984375 -27.875 L 3.1875 -27.4375 L 2.828125 -26.640625 L 2.828125 -24.25 L 2.625 -23.5625 L 2.78125 -21.890625 L 2.671875 -20.390625 L 2.859375 -18 L 2.703125 -17.234375 L 2.828125 -16.359375 L 2.75 -15.609375 L 2.78125 -14.8125 L 2.703125 -14.046875 L 2.828125 -12.46875 L 2.78125 -9.59375 L 2.90625 -8.4375 L 2.90625 -7.609375 L 3.140625 -6.8125 L 3.265625 -6.046875 L 3.5 -5.296875 L 4.296875 -3.9375 L 5.375 -2.625 L 5.890625 -2.109375 L 7.25 -1.3125 L 7.84375 -0.84375 L 8.59375 -0.515625 L 9.515625 -0.234375 L 10.109375 0.078125 L 10.984375 0.125 Z M 11.75 0.3125 "
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(384.130963, 163.62314)"
  }, /*#__PURE__*/React.createElement("g", null)))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(158.374249, 218.775664)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.90625 -1.109375 L 3.296875 -0.359375 L 4.53125 0.078125 L 8.921875 0.046875 L 9.71875 -0.359375 L 10.234375 -1.59375 L 10.1875 -2.828125 L 10.265625 -3.65625 L 10.15625 -5.375 L 10.1875 -6.125 L 10.15625 -6.890625 L 10.234375 -7.71875 L 10.59375 -8.5625 L 11.78125 -8.953125 L 18 -9 L 18.75 -9.359375 L 19.1875 -10.15625 L 19.15625 -11.03125 L 19.234375 -13.421875 L 19.109375 -14.171875 L 18.71875 -15.015625 L 17.515625 -15.40625 L 11.46875 -15.40625 L 10.546875 -15.71875 L 10.109375 -16.4375 L 10.109375 -18.796875 L 10.234375 -19.625 L 10.1875 -20.296875 L 10.59375 -21.09375 L 11.75 -21.5 L 12.90625 -21.453125 L 14.046875 -21.53125 L 16 -21.421875 L 16.796875 -21.5 L 18.4375 -21.421875 L 19.234375 -21.53125 L 19.984375 -21.890625 L 20.265625 -22.6875 L 20.265625 -23.453125 L 20.34375 -24.25 L 20.265625 -25 L 20.34375 -25.84375 L 20.265625 -26.671875 L 19.859375 -27.4375 L 19.15625 -27.796875 L 18.1875 -27.90625 L 16.765625 -27.796875 L 15.921875 -27.828125 L 15.09375 -27.796875 L 14.328125 -27.875 L 13.578125 -27.796875 L 4.0625 -27.796875 L 3.296875 -27.390625 L 2.859375 -26.640625 L 3.03125 -21.859375 L 2.953125 -21.09375 L 2.90625 -15.453125 L 3.03125 -14.734375 L 2.953125 -13.96875 L 2.953125 -13.171875 L 2.859375 -12.296875 L 3.03125 -11.0625 L 2.90625 -2.828125 L 2.984375 -1.90625 Z M 2.90625 -1.109375 "
  }))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(180.069872, 218.775664)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 3.0625 -1.28125 L 3.34375 -0.390625 L 4.140625 0 L 4.890625 0.046875 L 6.53125 -0.078125 L 7.359375 0 L 8.5625 0 L 9.796875 -0.390625 L 10.078125 -1.15625 L 10.15625 -1.984375 L 10 -2.828125 L 10.109375 -4.53125 L 10.03125 -7 L 10.390625 -7.796875 L 11.1875 -8.203125 L 11.90625 -8.203125 L 12.625 -8.234375 L 13.609375 -7.921875 L 14.25 -7.25 L 15.28125 -5.859375 L 15.5625 -5.09375 L 16.6875 -3.109375 L 17.203125 -2.34375 L 17.5625 -1.671875 L 18.03125 -1.03125 L 18.828125 -0.3125 L 19.828125 -0.078125 L 21.265625 0 L 22.140625 -0.078125 L 22.9375 0 L 24.53125 0 L 25.40625 -0.078125 L 26.234375 -0.28125 L 26.390625 -1.109375 L 25.875 -2.109375 L 24.609375 -4.0625 L 24.25 -4.734375 L 23.765625 -5.453125 L 23.375 -6.171875 L 22.859375 -6.8125 L 21.65625 -8.875 L 21.53125 -9.828125 L 21.96875 -10.671875 L 23.09375 -11.75 L 23.5625 -12.421875 L 23.84375 -13.171875 L 24.28125 -13.890625 L 24.5625 -14.578125 L 25 -16.078125 L 25.046875 -19.234375 L 24.84375 -19.984375 L 24.71875 -20.75 L 24.53125 -21.53125 L 23.453125 -23.734375 L 22.890625 -24.328125 L 22.53125 -24.921875 L 20.546875 -26.4375 L 19.15625 -27.15625 L 15.84375 -27.828125 L 14.84375 -27.90625 L 13.703125 -27.875 L 12.8125 -27.90625 L 12.015625 -27.828125 L 11.140625 -27.90625 L 10.46875 -27.828125 L 8.078125 -27.90625 L 7.328125 -27.796875 L 5.6875 -27.953125 L 4.9375 -27.828125 L 4.0625 -27.875 L 3.296875 -27.515625 L 2.984375 -26.671875 L 2.859375 -15.53125 L 2.984375 -14.375 L 2.984375 -12.375 L 2.90625 -11.546875 L 2.859375 -10.03125 L 2.984375 -9.15625 L 2.859375 -7.53125 L 3.03125 -5.21875 L 2.953125 -4.375 Z M 11.1875 -14.65625 L 10.515625 -15.015625 L 10.109375 -15.84375 L 10 -20.296875 L 10.46875 -21.09375 L 11.265625 -21.5 L 11.90625 -21.53125 L 14.09375 -21.5 L 15.921875 -21.265625 L 17.15625 -20.5 L 17.5625 -19.90625 L 17.84375 -19.265625 L 17.921875 -18.109375 L 17.796875 -17.046875 L 17.484375 -16.25 L 17.046875 -15.5625 L 16.5625 -15.09375 L 15.96875 -14.8125 L 12.859375 -14.53125 L 12.0625 -14.65625 Z M 11.1875 -14.65625 "
  }))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(207.657157, 218.775664)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 14.890625 0.484375 L 17.125 0.4375 L 19.515625 0.125 L 22.5 -0.875 L 23.8125 -1.59375 L 24.40625 -2.0625 L 25.15625 -2.421875 L 26.28125 -3.390625 L 26.796875 -4.09375 L 27.34375 -4.65625 L 29.109375 -7.328125 L 29.703125 -8.84375 L 30.015625 -10.34375 L 30.0625 -11.0625 L 30.25 -11.859375 L 30.296875 -12.703125 L 30.453125 -13.859375 L 30.34375 -15.84375 L 30.0625 -17.484375 L 29.0625 -20.46875 L 28.3125 -21.9375 L 27.4375 -23.125 L 26.3125 -24.359375 L 25.15625 -25.359375 L 24.25 -26 L 23.046875 -26.515625 L 22.453125 -26.953125 L 19.390625 -27.90625 L 17.078125 -28.3125 L 16 -28.34375 L 11.78125 -27.75 L 8.796875 -26.640625 L 8.203125 -26.203125 L 7.484375 -25.84375 L 6.125 -24.84375 L 4.1875 -22.578125 L 2.953125 -20.46875 L 2.34375 -18.953125 L 1.671875 -15.890625 L 1.546875 -12.65625 L 1.671875 -11.828125 L 1.875 -11.109375 L 1.953125 -10.34375 L 2.3125 -8.84375 L 4.140625 -5.21875 L 4.625 -4.734375 L 5.140625 -4.09375 L 5.734375 -3.546875 L 6.171875 -3.03125 L 7.484375 -1.984375 L 10.59375 -0.390625 L 11.75 0 L 12.625 0.078125 L 14.046875 0.390625 Z M 17.125 -6.5625 L 14.9375 -6.5625 L 14.046875 -6.6875 L 12.625 -7.28125 L 11.984375 -7.640625 L 10.90625 -8.515625 L 10.390625 -9.078125 L 9.828125 -9.828125 L 9.640625 -10.46875 L 9.28125 -11.1875 L 8.953125 -12.65625 L 8.953125 -15.09375 L 9.15625 -15.8125 L 9.28125 -16.5625 L 9.59375 -17.28125 L 9.828125 -18 L 10.796875 -19.265625 L 12.78125 -20.625 L 13.296875 -20.828125 L 14.84375 -21.21875 L 15.96875 -21.296875 L 17.875 -21.0625 L 18.59375 -20.90625 L 19.3125 -20.578125 L 20.546875 -19.703125 L 22.09375 -18.078125 L 22.578125 -16.5625 L 22.9375 -15.8125 L 23.046875 -15.09375 L 22.96875 -12.65625 L 22.65625 -11.1875 L 22.375 -10.46875 L 21.9375 -9.75 L 21.703125 -9.15625 L 21.140625 -8.515625 L 19.234375 -7.203125 L 18.515625 -7 L 17.921875 -6.734375 Z M 17.125 -6.5625 "
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(239.583564, 218.775664)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 2.953125 -1.15625 L 3.296875 -0.4375 L 4.265625 0 L 8.640625 -0.078125 L 9.828125 -0.4375 L 10.265625 -1.078125 L 10.34375 -1.828125 L 10.3125 -2.671875 L 10.1875 -3.5 L 10.3125 -8.875 L 10.15625 -11.1875 L 10.515625 -11.75 L 11.109375 -11.578125 L 12.109375 -10.34375 L 14.328125 -8.234375 L 14.84375 -7.5625 L 16.15625 -6.484375 L 17.078125 -6.484375 L 17.75 -6.96875 L 21.09375 -10.34375 L 21.625 -11.03125 L 22.171875 -11.578125 L 22.65625 -11.671875 L 22.96875 -11.1875 L 23.09375 -10.390625 L 22.96875 -9.640625 L 23.015625 -8.921875 L 22.96875 -8.125 L 23.09375 -6.65625 L 22.96875 -1.15625 L 23.375 -0.3125 L 24.25 0 L 29.015625 0.046875 L 29.78125 -0.4375 L 30.21875 -1.28125 L 30.34375 -2.0625 L 30.171875 -6.84375 L 30.25 -7.609375 L 30.171875 -9.15625 L 30.296875 -9.953125 L 30.25 -10.75 L 30.34375 -11.578125 L 30.25 -12.375 L 30.375 -13.09375 L 30.25 -24.359375 L 30.34375 -25.203125 L 30.25 -25.875 L 30.296875 -26.71875 L 29.859375 -27.46875 L 29.0625 -27.953125 L 27.875 -27.59375 L 26.875 -27.03125 L 25.953125 -25.921875 L 23.6875 -23.5625 L 23.328125 -22.96875 L 17.4375 -16.71875 L 16.5625 -16.4375 L 15.84375 -16.6875 L 15.328125 -17.203125 L 14.84375 -17.875 L 14.21875 -18.390625 L 13.734375 -19.03125 L 10.984375 -21.859375 L 10.03125 -23.046875 L 9.359375 -23.65625 L 8.84375 -24.203125 L 8.40625 -24.796875 L 7.84375 -25.328125 L 7.40625 -25.875 L 6.53125 -26.796875 L 5.375 -27.625 L 4.21875 -27.953125 L 3.421875 -27.515625 L 2.984375 -26.71875 L 2.90625 -25.875 L 3.03125 -8.328125 L 2.859375 -7.5625 L 3.03125 -1.90625 Z M 2.953125 -1.15625 "
  }))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(272.863457, 218.775664)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.640625 -10.03125 L 8 -9.203125 L 8.671875 -8.84375 L 11.828125 -8.765625 L 12.65625 -8.875 L 13.421875 -8.921875 L 14.21875 -9.234375 L 14.734375 -10.03125 L 15.40625 -11.5 L 15.8125 -12.1875 L 16.359375 -12.703125 L 17.4375 -13.890625 L 17.921875 -14.609375 L 18.359375 -15.125 L 19.671875 -17.234375 L 20.0625 -18.875 L 20.03125 -21.1875 L 19.90625 -21.96875 L 19.421875 -23.5625 L 18.984375 -24.328125 L 18.03125 -25.5625 L 17.359375 -26.203125 L 16.71875 -26.59375 L 16.046875 -26.90625 L 15.328125 -27.3125 L 13.859375 -27.875 L 12.984375 -27.953125 L 12.21875 -28.1875 L 10.984375 -28.3125 L 8.921875 -28.0625 L 8.203125 -27.828125 L 7.40625 -27.703125 L 6.609375 -27.3125 L 5.9375 -26.90625 L 5.21875 -26.640625 L 4.703125 -26.109375 L 4.09375 -25.59375 L 3.5 -24.96875 L 2.1875 -21.96875 L 2.109375 -21.1875 L 1.90625 -20.34375 L 2.234375 -19.59375 L 2.984375 -19.1875 L 3.75 -19.265625 L 4.859375 -19.1875 L 6.09375 -19.265625 L 6.765625 -19.15625 L 7.609375 -19.546875 L 8.484375 -20.984375 L 9.03125 -21.421875 L 9.640625 -21.78125 L 10.75 -21.859375 L 12.015625 -21.703125 L 12.65625 -21.421875 L 13.140625 -20.703125 L 13.21875 -19.59375 L 13.21875 -18.4375 L 12.9375 -17.71875 L 8.84375 -12.90625 L 8.40625 -12.1875 L 8.046875 -11.421875 Z M 7.125 -3.828125 L 7.171875 -2.390625 L 7.28125 -1.953125 L 7.484375 -1.515625 L 7.71875 -1.1875 L 8.15625 -0.84375 L 8.359375 -0.515625 L 9.28125 0 L 9.640625 0.125 L 10.15625 0.234375 L 11.546875 0.28125 L 11.984375 0.15625 L 12.375 0.15625 L 12.8125 0 L 13.34375 -0.3125 L 13.65625 -0.484375 L 14.015625 -0.796875 L 14.375 -1.1875 L 14.65625 -1.59375 L 15.015625 -2.828125 L 15.046875 -3.75 L 14.890625 -4.21875 L 14.8125 -4.65625 L 14.578125 -5.171875 L 14.296875 -5.578125 L 14.015625 -5.8125 L 13.734375 -6.203125 L 13.296875 -6.453125 L 12.9375 -6.6875 L 12.46875 -6.765625 L 11.9375 -6.96875 L 11.5 -7 L 10.59375 -6.96875 L 9.71875 -6.8125 L 9.203125 -6.65625 L 8.875 -6.484375 L 8.078125 -5.8125 L 7.4375 -5.140625 L 7.328125 -4.734375 L 7.125 -4.296875 Z M 7.125 -3.828125 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.f69b25c1a8bb8f34c979651b89c467b5.svg";
export { ForwardRef as ReactComponent };